import { InjectionToken } from '@angular/core';

export const CUSTOMERENVIRONMENT = new InjectionToken('customer-environment');
export const WINDOW = new InjectionToken('core-wp-window');
